// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"552e2a19","513":"0252d99c"}[chunkId] + ".chunk.js";
};